import React, {useContext, useState} from "react";
import SampleBlock from "../controllers/SampleBlock";
import {useValidationArray} from "../pages/validationArray";
import {showSuccessOrFailed} from "../Snacks";
import {arrayUpdatePartial} from "../immutableState";
import {EditRow, EditTable} from "./Fields";
import Input from "./Input";
import Dialog from "./Dialog";
import AppContext from "../appContext";
import {AxiosResponse} from "axios";

const EditBlockWaiting: React.FC<{
    getDataCallback: () => Promise<AxiosResponse<SampleBlock[]>>
    setDataCallback: (blocks: SampleBlock[]) => Promise<AxiosResponse<void>>
}> = (props) => {
    const context = useContext(AppContext)
    const [showSampleBlocks, setShowSampleBlocks] = useState<boolean>(false);
    const [sampleBlocks, setSampleBlocks] = useState<SampleBlock[]>([]);

    const validation = useValidationArray(sampleBlocks)({
        block: (block) => block.blockNumber.length > 0
    })
    function closeSampleBlocks() {
        setShowSampleBlocks(false);
        setSampleBlocks([])
    }
    function edit() {
        props.getDataCallback().then(resp => {
            setSampleBlocks(resp.data);
            setShowSampleBlocks(true)
        })
    }
    function saveBlockNames() {
        if (!validation.validate()) return;
        showSuccessOrFailed(context, props.setDataCallback(sampleBlocks))
            .then(() => {
                closeSampleBlocks()
            });
    }

    function editBlockName(v: string, index: number) {
        if (!sampleBlocks) return;
        const updatedSampleBlocks = arrayUpdatePartial(sampleBlocks, index, {blockNumber: v})
        setSampleBlocks(updatedSampleBlocks)
    }
    
    return <div>
        <div className="btn-primary btn-sm" onClick={() => edit()}>
            edit
        </div>
        <Dialog title={"Edit block names"} show={showSampleBlocks}
                setShow={() => closeSampleBlocks()}>
            <EditTable discard={() => closeSampleBlocks()}
                       save={() => saveBlockNames()}
                       saveWord={'update'}>
                {
                    validation.items.map((block, index) => (
                        EditRow(block.data.sampleNumber, <Input value={block.data.blockNumber}
                                                                change={v => editBlockName(v, index)}/>,
                            block.rules.block,
                            'Block name required'
                        )
                    ))
                }
            </EditTable>
        </Dialog>
    </div>
}

export default EditBlockWaiting